import * as React from 'react';
import Typography from "@mui/material/Typography/Typography";
import Stack from "@mui/material/Stack/Stack";
import Box from "@mui/material/Box/Box";
import IconButton from "@mui/material/IconButton/IconButton";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import moment from "moment/moment";
import {saveAs} from "file-saver";
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined";
import firebase from "../firebase/firebase";
import DownloadFileHelper from "./download-file-helper";
const storageRef = firebase.storage().ref();

export default function FileMessageComponent({msg, type}){

  const downloadURL = (url) => new Promise(((resolve, reject) => {
    const mediaRef = storageRef.child(url);

    mediaRef.getDownloadURL()
      .then((url) => {
        resolve(url);
      })
      .catch((error) => {
        reject(error)
        switch (error.code) {
          case 'storage/object-not-found':
            // File doesn't exist
            break;
          case 'storage/unauthorized':
            // User doesn't have permission to access the object
            break;
          case 'storage/canceled':
            // User canceled the upload
            break;
          case 'storage/unknown':
            // Unknown error occurred, inspect the server response
            break;
        }

      });
  }))
  const fileIconColor = (name) => {
    if (name === 'pdf') {
      return '#ED1C24'
    } else if (name === 'doc' || name === 'docx' ) {
      return '#1ab1e8'
    } else if (name === 'xls' || name === 'xlsx') {
      return '#00a954'
    }else {
      return '#a77b00'
    }
  }
  if (type === 'r') {
    return (

      <Stack direction={'row-reverse'} spacing={1}>
        <Stack direction={'row'} spacing={1} sx={{ p:1, backgroundColor: '#204488',  color: '#fff', borderRadius: '5px', maxWidth:'80%'}} justifyContent="flex-end"
               alignItems="flex-end">
          <Stack direction={'row'} spacing={2} justifyContent="flex-start"
                 alignItems="center">
            <Box sx={{

              background: fileIconColor(msg?.file.split('.')[msg?.file.split('.').length -1]),
              borderRadius: '3px',
              color:'#fff',
              fontSize:'small',
              padding: '14px 7px',
              textTransform:'uppercase'
            }} >

              {msg?.file.split('.')[msg?.file.split('.').length -1]}</Box>
            <Typography variant={'body2'} sx={{ flex:1}} >
              {
                msg?.file.length < 100 ? <>
                {msg?.file.split('/')[msg?.file.split('/').length -1]} 
                </> :
                <>
                {(msg?.file.split('/')[msg?.file.split('/').length -1]).substr(0 , 12)}.....{
                  (msg?.file.split('/')[msg?.file.split('/').length -1]).substr(-12)
                }
                </>
              }
              
            </Typography>
            <IconButton size={'small'} variant={'outlined'} color={'secondary'} sx={{border: '1px solid #4acfee'}} onClick={ () => {
              DownloadFileHelper(msg?.file)

            }
            }>
              <FileDownloadOutlinedIcon style={{color: '#4acfee',fontSize: 18}}/>
            </IconButton>
          </Stack>
          <Stack direction={'row'} spacing={.5}>

            <Typography variant={'caption'}>
              {msg.createdAt && moment(msg.createdAt.seconds * 1000).format('HH:mm')}
            </Typography>

            {msg.read === true ?    <DoneAllOutlinedIcon style={{color: '#4acfee',fontSize: 18}}  /> :<DoneAllOutlinedIcon  style={{color:'#ccc',fontSize: 18}}/>

            }

          </Stack>
        </Stack>
      </Stack>
    )
  } else {
    return (
      <Stack direction={'row'} spacing={1}>
        <Stack direction={'row'} spacing={1} sx={{ p:1, backgroundColor:'#F1F1F1', borderRadius: '5px', maxWidth:'70%'}} justifyContent="flex-end"
               alignItems="flex-end">
          <Stack
            direction={'row'}
                 spacing={2} justifyContent="flex-start"
                 alignItems="center">
            <Box sx={{

              background: fileIconColor(msg?.file.split('.')[msg?.file.split('.').length -1]),
              borderRadius: '3px',
              color:'#fff',
              fontSize:'small',
              padding: '14px 7px',
              textTransform:'uppercase'
            }} >

              {msg?.file.split('.')[msg?.file.split('.').length -1]}</Box>
            <Typography variant={'body2'} sx={{ flex:1}} >
              {msg?.file.split('/')[msg?.file.split('/').length -1]}
            </Typography>
            <IconButton size={'small'} variant={'outlined'} color={'secondary'} sx={{border: '1px solid #828787'}} onClick={ () => {
              DownloadFileHelper(msg?.file)
            }
            }>
              <FileDownloadOutlinedIcon color={'secondary'} style={{fontSize: 18}}/>
            </IconButton>
          </Stack>

          <Stack direction={'row'} spacing={.5}>

            <Typography variant={'caption'} color={'secondary'}>
              {msg.createdAt && moment(msg.createdAt.seconds * 1000).format('HH:mm')}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    )
  }
}